import {
    selectExecutionStatus,
    selectHasRealOpenTrade,
    useTradingStore,
} from '../store';

interface ExecutionDisplay {
    executionInFlight: boolean;
    executionLabel: string | null;
}

/**
 * Maps the backend-executed trade lifecycle into button copy + an in-flight
 * flag. All real trades are executed gaslessly by the backend, so this is just
 * "is a request in flight" plus a status label — there is no per-trade signing
 * or relay-vs-direct distinction anymore.
 */
export function useExecutionDisplay(): ExecutionDisplay {
    const executionStatus = useTradingStore(selectExecutionStatus);
    const executionPhase = useTradingStore((s) => s.executionPhase);
    const hasRealOpenTrade = useTradingStore(selectHasRealOpenTrade);

    const executionInFlight =
        executionStatus === 'submitting' || executionStatus === 'closing';

    const executionLabel =
        executionStatus === 'submitting'
            ? hasRealOpenTrade
                ? 'Closing...'
                : executionPhase === 'configuring'
                    ? 'Configuring...'
                    : 'Submitting...'
            : executionStatus === 'pending'
                ? 'Confirming...'
                : executionStatus === 'closing'
                    ? 'Closing...'
                    : executionStatus === 'open'
                        ? 'Synced'
                        : null;

    return { executionInFlight, executionLabel };
}
